import Tabs, { Tab } from '@/components/ui/tabs';
import { useAdmin } from '@/hooks/useAdmin';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

export enum AdminTabsEnum {
  ReportingTools = 'Reporting Tools',
  ManageStaff = 'Manage Staff',
}

export const AdminTabs = ({ activeTab }: { activeTab: AdminTabsEnum }) => {
  const { authentication } = useAuthentication();
  // const navigate = useNavigate();
  const { page } = useAdmin();

  const [tabs, setTabs] = useState<Tab[]>([
    {
      name: page?.adminTabs?.reportingTools || 'Reporting Tools',
      href: '/reporting-tools',
      current: activeTab === 'Reporting Tools',
    },
    {
      name: page?.adminTabs?.manageStaff || 'Manage Staff',
      href: '/manage-staff',
      current: activeTab === 'Manage Staff',
    },
  ]);

  useEffect(() => {
    if (!authentication || !authentication.user) {
      return;
    }

    if (!authentication.user.access_control_list?.manageStaff) {
      tabs.splice(1, 1);
    }

    setTabs([...tabs]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authentication]);
  return (
    <div className=" flex w-full justify-center">
      <Tabs tabs={tabs} setTabs={() => {}} />
    </div>
  );
};
